const LocaleEN = {
    abbr: 'en',    
    months : 'january_february_march_april_may_june_july_august_september_october_november_december'.split('_'),
    monthsShort : 'jan_feb_mar_apr_may_jun_jul_aug_sep_oct_nov_dec'.split('_'),
    weekdays : 'sunday_monday_tuesday_wednesday_thursday_friday_saturday'.split('_'),
    weekdaysShort : 'ssun_mon_tue_wed_thu_fri_sat'.split('_'),
    weekdaysMin : 'su_mo_tu_we_th_fr_sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd [,] D. MMMM YYYY [at] HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'next dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last Week] dddd[. at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'In %s',
        past : '%s Ago',
        s : 'a few seconds',
        m : 'One Minute',
        mm : '%d Minutes',
        h : 'One Hour',
        hh : '%d Hours',
        d : 'One Day',
        dd : '%d Days',
        M : 'One Month',
        MM : '%d Months',
        y : 'One Year',
        yy : '%d Years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    },
    previousMonth : 'Previous Month',
    nextMonth     : 'Next Month'
};



export default LocaleEN;